export default function () {
  const yearParagraphs = document.querySelectorAll('.promo__year');
  const currentYear = new Date().toLocaleDateString('en-US', { year: 'numeric' });

  if (yearParagraphs.length > 0) {
    yearParagraphs.forEach((paragraph) => {
      paragraph.innerText = currentYear;
    });
  }
}